<template>
  <BuiEntityListingPage
    v-bind="listNamesConfig"
    :ItemsLister="SubscriptionsLister"
    :itemsListerBind="{ buiColumns: playerSubscriptionsColumns }"
    :createItemPage="canCreate"
    @create="createDialog?.openModal()"
  />

  <!-- Create Player Subscription modal — Phase 3 create-modal template (see PlaylistsListView). -->
  <Dialog ref="createDialog" panelClass="bui-dialog-panel">
    <template #dialog.title>Create Player Subscription</template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <CreateSubscriptionForm @cancel="closeModal" @success="closeModalAfter(1000)" />
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import Dialog from '@/components/Dialog/Dialog.vue';
import CreateSubscriptionForm from './CreateSubscriptionForm/CreateSubscriptionForm.vue';
import SubscriptionsLister from './SubscriptionsLister/SubscriptionsLister.vue';
import listNamesConfig from "./SubscriptionsLister/config/listNames.config";
import playerSubscriptionsColumns from "./SubscriptionsLister/config/tableColumns.config";
import useUser from '@/composables/user';

const user = useUser();
const createDialog = ref();
const canCreate = computed(() => user.hasCreateAccessToArea(listNamesConfig.areaAccessName));
</script>

<style lang="scss" scoped>
</style>
